import { useUserInfo } from '@/layers/core/deal/services/useUserInfo';

const useModulePermissions = () => {
  const { data } = useUserInfo();
  return data?.module_permissions;
};

export { useModulePermissions };
